export enum EnumEconomicActivity {
  Employee = 3,
  Independent = 4,
  IndependentWithBusiness = 9, // 4 code changed for logic validations
  Student = 5,
  WorkHome = 1,
  Pensioner = 8
}
